const css = `.Vw2_xG__scroller{grid-template-columns:repeat(1,max-content);row-gap:8px;padding:8px 4px;transition:transform .25s ease-out;display:grid}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"scroller":"Vw2_xG__scroller"};
